import { createFileRoute } from "@tanstack/react-router";
import AuthorsIndex from "@/pages/AuthorsIndex";

export const Route = createFileRoute("/authors/")({
  component: AuthorsIndex,
});
